import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContentPagesRoutingModule } from './content-pages-routing.module';

import {
    MatButtonModule,
    MatCardModule, MatDatepickerModule, MatDialogModule, MatExpansionModule,
    MatGridListModule,
    MatIconModule, MatInputModule,
    MatListModule,
    MatMenuModule, MatNativeDateModule, MatRadioModule, MatSelectModule, MatSnackBarModule,
    MatTabsModule, MatTooltipModule
} from '@angular/material';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import {
    DxButtonModule,
    DxDataGridModule,
    DxDateBoxModule, DxNumberBoxModule,
    DxPopoverModule,
    DxPopupModule,
    DxSelectBoxModule, DxTagBoxModule,
    DxTemplateModule, DxTextBoxModule,
    DxTreeListModule, DxValidatorModule
} from 'devextreme-angular';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HighchartsChartModule } from 'highcharts-angular';
import { AppEmbadedSoftComponent } from './app-embaded-soft/app-embaded-soft.component';
import { AppLoadingComponent } from './app-loader/app-loading.component';


@NgModule({
    imports: [
        HttpClientModule,
        CommonModule,
        ContentPagesRoutingModule,
        MatIconModule,
        MatGridListModule,
        MatMenuModule,
        MatCardModule,
        NgxChartsModule,
        MatIconModule,
        MatButtonModule,
        DxDataGridModule,
        DxTemplateModule,
        DxPopoverModule,
        DxPopupModule,
        MatTabsModule,
        MatListModule,
        DxTreeListModule,
        MatDialogModule,
        FormsModule,
        MatSelectModule,
        ReactiveFormsModule,
        MatSnackBarModule,
        MatInputModule,
        MatTooltipModule,
        MatExpansionModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatRadioModule,
        HighchartsChartModule,
        DxDateBoxModule,
        DxSelectBoxModule,
        DxTextBoxModule,
        DxTagBoxModule,
        DxNumberBoxModule,
        DxValidatorModule,
        DxButtonModule
    ],
    providers: [
        MatDatepickerModule,
    ],
    declarations: [
        AppEmbadedSoftComponent,
        AppLoadingComponent

    ],
    entryComponents: [

    ]
})
export class ContentPagesModule { }
